import {
  getSignature,
  setSignature,
  forgetSignature,
  TriageSession,
  newRecentSession,
  STORAGE_KEY
} from './common';

export const getTriageSession: getSignature = (): TriageSession | boolean => {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value !== null) {
      return JSON.parse(value);
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const setTriageSession: setSignature = (sessionToken: string): TriageSession | boolean => {
  try {
    const newSession = newRecentSession(sessionToken);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newSession));
    return newSession;
  } catch (e) {
    return false;
  }
};

export const forgetTriageSession: forgetSignature = (): boolean => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    return false;
  }
  return true;
};
